<template>
    <div class="service-videos">
        <video-watcher :watch="watching" @changeVideo="changeVideo"></video-watcher>
        <search-result :facets="facets" hide-categories>
            <template v-slot:results="props">

                <search-result-group :raw-results="props.results" :sorting="sorting">
                    <template v-slot:result="props">

                        <div class="col-sm-4">
                            <videos-result-video :result="props.result" @watch="watch"></videos-result-video>
                        </div>
                    </template>
                </search-result-group>

            </template>
            <!--            <template v-slot:additionalFilter="props">-->
            <!--                <div class="col-sm-4">-->
            <!--                    <filter-category-label-cloud :results="results" ></filter-category-label-cloud>-->
            <!--                </div>-->
            <!--            </template>-->
        </search-result>
    </div>
</template>

<script>
    import SearchResult from './SearchResult';
    import VideosResultVideo from "@/components/VideosResultVideo";
    import SearchResultGroup from "./SearchResultGroup";
    import VideoWatcher from "@/components/VideoWatcher";
    import FilterCategoryLabelCloud from "@/components/FilterCategoryLabelcloud";
    import FilterFacetTypeId from "@/components/FilterFacetTypeId";


    let scrollOptions = {
        force: true,
        cancelable: true,
        offset: -200
    };

    export default {
        name: "ServiceVideos",
        components: {
            FilterCategoryLabelCloud,
            VideoWatcher,
            SearchResultGroup,
            VideosResultVideo,
            SearchResult,
            FilterFacetTypeId
        },
        data: function () {
            return {
                watching: null,
                resultTypes: {default: VideosResultVideo},
                sortings: [
                    'asc', 'desc', 'date', 'relevance'
                ],
                selections: {
                    searchFilter: [],
                    languageFilter: [],
                },
                sorting: 'relevance',
                facets: [
                    {
                        component: FilterCategoryLabelCloud,
                        binding: 'level_0',
                        classes: ['col-sm-4'],
                        facetName: 'level_0'
                    },
                  {
                    component: FilterFacetTypeId,
                    binding: 'lang',
                    classes: ['col-sm-3'],
                    facetName: 'lang',
                    getOptionName: function (id) {
                      return id.toUpperCase();
                    },
                    filterOptions(option) {
                      return option.toLowerCase() !== 'nn';
                    }
                  }
                ]
            };
        },
        computed: {
            resultState() {
                return this.$store.state.status.results;
            },
            results() {
                return this.$store.state.results;
            }
        },
        watch: {
            watching() {

            },
            resultState() {
                if (this.resultState === 'finished' && this.results !== null) {
                    let q;
                    if (this.$route.query && (q = this.$route.query)) {
                        if (this.results[q.watch]) {
                            this.watching = {lang: q.lang, result: {languages: this.results[q.watch]}};
                        }
                    }
                }

            }
        },
        methods: {

            changeVideo(e) {
                this.$router.push({
                    name: 'videos',
                    query: {watch: this.watching.result.fields.document_id, lang: this.watching.lang}
                })
            },
            watch(e) {
                let $this = this;
                this.watching = e;
                this.$nextTick(() => {
                    let elem = $this.$el;
                    if (elem) {
                        $this.$scrollTo(elem, 800, scrollOptions);
                    }
                });
            }
        },
        created() {
            this.$store.commit('selectService', 'videos');
            this.$store.commit('results', null);

            Promise.all([this.$store.dispatch('fetchCategories'), this.$store.dispatch('getResults')]);
        }
    }

</script>

<style scoped>

</style>
